module.exports = __webpack_public_path__ + "img/priceAdjustment.42bed4a9.png";